var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("app-mobile-full-screen-container", [
    _c(
      "div",
      { staticClass: "w100" },
      [
        _c(
          "w-breadcrumb",
          { attrs: { crumbs: _vm.path } },
          [
            _c("w-spacer"),
            _vm.$wf.isMdUp
              ? _c(
                  "w-button",
                  {
                    attrs: { disabled: _vm.saving },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("common.save")) + " ")]
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "w-scroll-view",
          { attrs: { tag: "w-container" } },
          [
            _c(
              "w-row",
              [
                _c(
                  "w-col",
                  { attrs: { sm: "12", md: "12" } },
                  [
                    _c(
                      "w-card",
                      [
                        _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title")))]),
                        _c(
                          "w-card-content",
                          [
                            _vm.connected
                              ? _c(
                                  "w-row",
                                  [
                                    _c("w-col", [
                                      _c("div", { staticClass: "connected" }, [
                                        _vm._v(_vm._s(_vm.$ct("connected"))),
                                      ]),
                                    ]),
                                  ],
                                  1
                                )
                              : _c(
                                  "w-row",
                                  [
                                    _c("w-col", [
                                      _c(
                                        "div",
                                        { staticClass: "not-connected" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$ct("not-connected"))
                                          ),
                                        ]
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                            _c(
                              "w-row",
                              [
                                _c(
                                  "w-col",
                                  [
                                    _c("w-input", {
                                      attrs: {
                                        fancy: "",
                                        label: _vm.$ct("host"),
                                      },
                                      model: {
                                        value: _vm.config.host,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.config, "host", $$v)
                                        },
                                        expression: "config.host",
                                      },
                                    }),
                                    _c("w-input", {
                                      staticClass: "mt",
                                      attrs: {
                                        fancy: "",
                                        label: _vm.$ct("username"),
                                      },
                                      model: {
                                        value: _vm.config.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.config, "name", $$v)
                                        },
                                        expression: "config.name",
                                      },
                                    }),
                                    _c("w-input", {
                                      staticClass: "mt",
                                      attrs: {
                                        fancy: "",
                                        label: _vm.$ct("password"),
                                      },
                                      model: {
                                        value: _vm.config.password,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.config, "password", $$v)
                                        },
                                        expression: "config.password",
                                      },
                                    }),
                                    _c("w-checkbox", {
                                      staticClass: "mt",
                                      attrs: { label: _vm.$ct("show-screen") },
                                      model: {
                                        value: _vm.config.showScreen,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.config,
                                            "showScreen",
                                            $$v
                                          )
                                        },
                                        expression: "config.showScreen",
                                      },
                                    }),
                                    _vm.config.showScreen
                                      ? _c("w-input", {
                                          staticClass: "mt",
                                          attrs: {
                                            fancy: "",
                                            label: _vm.$ct("screen-url"),
                                            placeholder: _vm.defaultScreenUrl,
                                          },
                                          model: {
                                            value: _vm.config.screenUrl,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.config,
                                                "screenUrl",
                                                $$v
                                              )
                                            },
                                            expression: "config.screenUrl",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("w-col", { attrs: { sm: "12", md: "6" } }),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }